import React from 'react';

const ContactPage = () => (
    <React.Fragment>
          <h2 className="page-heading">Contact Us</h2>

    <h4 className="team-title" >Working @ Lei Lab</h4>
    <p className="paragraphContent">Currently, there's no opening for post-doc or graduate students. However, Department of Physics and Astronomy is now accepting the application of summer research internship. Undergraduates feeling interested in our research studio can get financial support from the department for their summer research. 
    Here is the application link:  </p>
    <a href="https://gsu.qualtrics.com/jfe/form/SV_85MLWJC1eqOl8r3">https://gsu.qualtrics.com/jfe/form/SV_85MLWJC1eqOl8r3</a>


<h4 className="team-title" >Contact Dr. Lei</h4>
        <a ><strong>Sidong Lei Ph.D.<br />
        </strong>Assistant Professor of Physics<br />
        Department of Physics and Astronomy<br />
        Georgia State University<br />
        25 Park Place, 25 Park Pl NE #605<br />
        Atlanta, GA 30303</a>
        <a>&nbsp;</a>
        <a>Office: 456 Science Annex<br />
        Tel: (404)413-6104<br />
        Email: slei@gsu.edu</a>
        <a></a>
    </React.Fragment>
    
)

export default ContactPage;